import React from 'react';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5022';

function App() {
  const params = new URLSearchParams(window.location.search);
  const widgetId = params.get('id') || params.get('widgetKey');

  if (!widgetId) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <h2 style={styles.heading}>Booking Not Found</h2>
          <p style={styles.text}>No booking page was specified. Please use the link provided by your practitioner.</p>
        </div>
      </div>
    );
  }

  const embedUrl = `${API_BASE}/api/widget/${widgetId}/embed.html`;

  return (
    <iframe
      src={embedUrl}
      title="Book Appointment"
      style={styles.frame}
      frameBorder="0"
      scrolling="auto"
    />
  );
}

const styles = {
  frame: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 'none',
  },
  page: {
    minHeight: '100vh',
    background: '#f4f6f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 16px',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  card: {
    background: '#fff',
    borderRadius: '8px',
    padding: '40px',
    maxWidth: '480px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    textAlign: 'center',
  },
  heading: {
    color: '#1a2942',
    marginBottom: '12px',
  },
  text: {
    color: '#666',
    lineHeight: '1.6',
  },
};

export default App;
